import { useState } from 'react';
import { TeamsNewsQuery, TeamsNewsQueryVariables, rubyQueries } from 'queries';
import PageLayout from '@/components/PageLayout';
import Page from '@/components/Page';
import TeamSubNav from '@/components/subNavs/TeamSubNav';
import { entryPoint } from 'react_rails/entryPoint';
import ContentSection from '@/components/ContentSection';
import PageHeader from '@/components/PageHeader';
import ApplicationShareButton from 'containers/ApplicationContainer/components/ApplicationShareButton';
import InfinitePagination from '@/components/InfinitePagination';
import NewsFeed from '@/components/modules/NewsFeed';
import filterArticles from 'helpers/filterArticles';
import MinuteMediaAd from '@/components/ads/MinuteMediaAd';
import OutbrainAd from '@/components/ads/OutbrainAd';

export default entryPoint(function News({ query: { team }, variables }: { query: TeamsNewsQuery; variables: TeamsNewsQueryVariables }) {
  const [articles, setArticles] = useState(filterArticles(team.articles.nodes));

  return (
    <Page subNav={<TeamSubNav team={team} />}>
      <PageLayout
        sidebar={
          <>
            <MinuteMediaAd placement="SIDEBAR" />
            <MinuteMediaAd placement="SIDEBAR_2" />
          </>
        }
      >
        <ContentSection>
          <PageHeader right={<ApplicationShareButton />}>News & Updates</PageHeader>
          <InfinitePagination
            onLoadMore={({
              team: {
                articles: { nodes, pageInfo }
              }
            }) => {
              setArticles(articles => [...articles, ...filterArticles(nodes)]);
              return pageInfo;
            }}
            pageInfo={team.articles.pageInfo}
            query={rubyQueries.teamsNewsQuery}
            ttl={60 * 5}
            variables={variables}
          >
            <NewsFeed articles={articles} defaultAuthorImage={team.image} />
          </InfinitePagination>
        </ContentSection>
        <OutbrainAd />
      </PageLayout>
    </Page>
  );
});
